// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingVatListResponse

import { hydrateBillingVat, type BillingVat, type BillingVatApiResponse } from './billingVat.gen';

export type BillingVatListApiResponse = {
	items: BillingVatApiResponse[];
};

export type BillingVatList = {
	items: BillingVat[];
};

export function hydrateBillingVatList(data: BillingVatListApiResponse): BillingVatList {
	return {
		...data,
		items: data.items.map(hydrateBillingVat),
	};
}